import React from "react"

import { gql } from "@urql/core"

import { useQuery } from "hooks/urql"

import UrqlLoadingIndicator from "components/WithLoadingIndicator/urql"

import Form from "./Form"

const EditTutor = ({ tutorId, canAdminExpenses, canAdminBudgets }) => {
  const [result] = useQuery({
    query: tutorQuery,
    variables: { tutorId },
  })

  return (
    <UrqlLoadingIndicator result={result}>
      {({ data }) => (
        <Form
          tutor={data.tutor}
          tiers={data.tiers}
          canAdminExpenses={canAdminExpenses}
          canAdminBudgets={canAdminBudgets}
        />
      )}
    </UrqlLoadingIndicator>
  )
}

const tutorQuery = gql`
  query AdminTutorFormEdit($tutorId: ID!) {
    tutor(id: $tutorId) {
      id
      firstName
      lastName
      email
      phoneNumber
      bio
      emailTimeZone
      disableTutorNotifications
      messageEmailsEnabled
      activeCourseStudyGroupLimit
      canSubmitGeneralExpenses
      hasSubmittedFingerprintExpense
      hasSubmittedIntroSessionExpense
      billDotComVendorId
      onDemandTutor
      billableName
      floridaTutoringAdvantageId
      messagingDisabled
      tiers {
        id
      }
      address {
        country
        region
      }
    }
    tiers {
      id
      gradeRange
      order
    }
  }
`

export default EditTutor
